<template>
  <div class="wrapper">
    <side-bar></side-bar>
    <div class="main-panel">
      <!-- Navbar -->
      <nav-bar></nav-bar>
      <div class="content">
        <router-view></router-view>
      </div>
      <footer class="footer footer-black footer-white">
        <div class="container-fluid">
          <div class="row">
            <nav class="footer-nav">
              <ul>
                <li>
                  <a href="https://www.systems.nakashima.co.jp/" target="_blank">Systems Nakashima</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import Sidebar from '../../components/Sidebar';
import Navbar from "../../components/Navbar";
import AuthService from '../../services/AuthService';

export default {
  components: {
    'side-bar': Sidebar,
    'nav-bar': Navbar,
  },
  data() {
        return {
            windowSize: {
                width: 0,
                height: 0
            },
            isMobileMode: false
        }

    },
    created() {
        window.addEventListener('resize', this.handleResize);
        const userId = AuthService.getUserCurrentLogin().id;
        AuthService.getUserAfterUpdate(userId);
    },
    mounted() {
        this.showNavbarMobile();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        handleResize() {
            this.windowSize.width = window.innerWidth;
            this.windowSize.height = window.innerHeight;
            this.updateNavBarWhenChangeWindowSize();
        },
        showNavbarMobile() {
            //  Show or hide navbar-left
            const elementControlShowNavbarLeft = document.querySelector(
                "div#is-show-navbar"
            );
            const navbarLeft = document.querySelector(
                ".navbar-wrapper .navbar-toggle"
            );
            navbarLeft.addEventListener("click", function () {
                elementControlShowNavbarLeft.classList.toggle("nav-open");
            });
        },
        updateNavBarWhenChangeWindowSize() {
            // Show or hide navbar-right toggle
            const navbarRight = document.querySelector("nav#navbar-right-navigation");
            const contentNavbarRight = document.querySelector(
                "nav#navbar-right-navigation div#navigation"
            );
            if (this.windowSize.width > 992) {
                if (this.isMobileMode === true) {
                    this.isMobileMode = false;
                    contentNavbarRight.style.height = 0;
                    navbarRight.classList.remove("bg-white");
                    contentNavbarRight.classList.remove("show");
                    navbarRight.classList.add("navbar-transparent");
                }
            } else {
                this.isMobileMode = true;
            }
        }
    },
};
</script>
<style lang="scss">
@media screen and (max-width: 992px) {
    #navigation {
        height: 0;
        opacity: 1;
        transition: all 0.4s ease;
        overflow: hidden;
        display: block;
    }
}
</style>
